export default {
      id: "paperclip-usage",
      viewBox: "0 0 219.6 218.97",
      url: __webpack_public_path__ + "img/icons.0fe16570.svg#paperclip-usage",
      toString: function () {
        return this.url;
      }
    }